export default function pageSidebar() {
    return {
        restrict: "E",
        scope: {
            title: "@",
            text: "@"
        },
        replace: false,
        template: require("./template.html")

        // link: function(scope, element, attrs) {},
        // controller: function($scope) {}
    };
}
